import { Component, signal, Signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CustomerAutocompleteComponent } from '@libs/account/components';
import { ButtonComponent } from '@libs/common/components';
import { AuthService } from '@libs/shared/auth';
import { FlashMessageModule, FlashMessageService, SpinnerOverlayService } from '@libs/shared/common';
import { CustomerModel } from '@libs/account/models';

@Component({
  selector: 'ui-customer-context-switch',
  templateUrl: './customer-context-switch.component.html',
  styleUrls: ['customer-context-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatButtonModule,
    FlashMessageModule,
    CustomerAutocompleteComponent,
    ButtonComponent,
  ],
})
export class CustomerContextSwitchComponent {
  public customers: Signal<CustomerModel[] | undefined> = this.authService.allCustomers;
  public current: Signal<CustomerModel | undefined> = this.authService.currentCustomer;
  public selected: WritableSignal<CustomerModel | undefined> = signal(undefined);

  public constructor(
    private readonly authService: AuthService,
    private readonly flashMessage: FlashMessageService,
    private readonly spinnerOverlay: SpinnerOverlayService,
  ) {
  }

  public customerSelected(customer: CustomerModel | undefined): void {
    this.selected.set(customer);
  }

  public changeContext(): void {
    const selectedCustomer: CustomerModel | undefined = this.selected();

    if (!selectedCustomer) {
      return;
    }

    this.spinnerOverlay.showLoader();
    void this.authService.changeCustomer(selectedCustomer).then(() => {
      this.flashMessage.showMessage('successCustomerSwitch');
    }).catch(() => void this.flashMessage.showMessage('errorCustomerSwitch'))
      .finally(() => void this.spinnerOverlay.hideLoader());
  }
}
